<template>
  <div class="modal fade" id="avrModal" tabindex="-1" aria-labelledby="avrModal" aria-hidden="true"
       @keydown.esc="clearForm">
    <div class="modal-dialog modal-dialog-centered modal-dialog-scrollable modal-xl">
      <div class="modal-content" v-if="!this.loader">
        <div class="modal-header p-5" v-if="item">
          <h5 class="modal-title" id="clientModalLabel">
            <small class="text-gray-500 fw-normal">Номер:</small> {{ avrModel.title }} &nbsp;
            <small class="text-gray-500 fw-normal">Дата:</small> {{ item.date }}
          </h5>
          <button type="button" @click="clearForm" class="btn-close" data-bs-dismiss="modal"
                  aria-label="Close"></button>
        </div>
        <div class="modal-body p-5" v-if="item">
          <div class="row">
            <div class="col-lg-9">
              <object
                  :data="'data:application/pdf;base64,'+item.document+'#view=Fit'"
                  type="application/pdf"
                  width="100%"
                  style="height: 60vh"
              />
            </div>
            <div v-if="item.confirmed === null && item.has_action" class="col-lg-3">
              <div v-if="error" class="alert alert-danger d-flex align-items-center p-5">
                <div class="d-flex flex-column">
                  <span v-html="error"></span>
                </div>
              </div>
              <template v-if="this.step >= 1">
                <div class="alert alert-primary p-5 text-center">
                  <span>Код отправлен по номеру <br> <b>{{ this.phone }}</b></span>
                  <br>
                  <span>На подтверждение кода у вас есть: <b>30 минут</b></span>
                </div>
                <input-mask-field
                    v-model="this.code"
                    id="form.code"
                    name="form_code"
                    :required="true"
                    :mb="5"
                    placeholder="Код"
                    mask="####"
                    type="text"
                />
                <button v-if="step === 1" class="btn btn-xs btn-warning btn-block" :disabled="this.timer !== 0" @click="sendConfirmed(item.id, 1)">
                  <span class="indicator-label">Повторно отправить код <br>
                    <span v-if="this.timer > 0"> через {{ this.timer }} сек.</span>
                  </span>
                </button>
                <button v-if="step === 2" class="btn btn-xs btn-primary btn-block" @click="checkCode(item.id)">
                  <span class="indicator-label">Подтвердить код</span>
                </button>
              </template>
              <div class="row" v-if="this.step < 1">
                <div class="col-12" v-if="canceled">
                  <area-field
                      v-model="comment"
                      v-if="canceled"
                      id="avr.comment"
                      :class="'h-125px'"
                      name="avr.comment"
                      :required="true"
                      class="h-auto"
                      placeholder="Комментарий"
                      mb="5"
                  />
                  <div class="row">
                    <div class="col-6">
                      <button @click="canceled = false" type="button" class="btn btn-xs btn-danger btn-block">
                        Отмена
                      </button>
                    </div>
                    <div class="col-6">
                      <button
                          @click="sendConfirmed(item.id, 0)"
                          type="button"
                          class="btn btn-xs btn-warning btn-block"
                          :disabled="!comment.length"
                      >
                        Отказать
                      </button>
                    </div>
                  </div>
                </div>
                <template v-else>
                  <div class="col-6">
                    <button @click="canceled = true" type="button" class="btn btn-xs btn-warning btn-block">
                      Отказать
                    </button>
                  </div>
                  <div class="col-6">
                    <button @click="sendConfirmed(item.id, 1)" type="button" class="btn btn-xs btn-primary btn-block">
                      Принять
                    </button>
                  </div>
                </template>
              </div>
            </div>
            <div v-else class="col-lg-3">
              <template v-if="!item.has_action">
                <div class="alert alert-danger p-5">
                  <div class="text-center">
                    <span>Время согласования вышло</span>
                  </div>
                </div>
                <hr class="text-gray-400">
              </template>
              <div data-v-ad026786="" class="fw-bold text-primary mb-2">Информация</div>
              <hr class="text-gray-400">
              <div class="text-gray-500 mb-1">
                Номер:
                <span class="float-end text-gray-700 fw-bold" v-html="item.number"></span>
              </div>
              <div class="text-gray-500 mb-1">
                Дата:
                <span class="float-end text-gray-700 fw-bold" v-html="item.date"></span>
              </div>
              <div class="text-gray-500 mb-1">
                Подтвержден:
                <span class="float-end text-gray-700 fw-bold" v-html="item.confirmed === null ? 'Необработанный' : item.confirmed === 0 ? 'Нет' : 'Да'"></span>
              </div>
              <div class="text-gray-500 mb-1">
                Оплачено:
                <span class="float-end text-gray-700 fw-bold" v-html="item.is_paid === null ? 'Необработанный' : item.is_paid === 0 ? 'Нет' : 'Да'"></span>
              </div>
            </div>
          </div>
        </div>
        <div class="modal-footer p-3 justify-content-center">
          <button
              type="button"
              class="btn btn-sm btn-secondary"
              data-bs-dismiss="modal"
          >Закрыть
          </button>
        </div>
      </div>
      <div v-else class="modal-content">
        <loader-full style="height: 400px"/>
      </div>
    </div>
  </div>
</template>

<script>
import InputMaskField from "@/components/Fields/InputMaskField.vue";
import LoaderFull     from '@/components/Main/LoaderFull'
import AreaField      from "@/components/Fields/AreaField.vue";
import axios          from 'axios';

export default {
  name: 'AvrModal',
  components: { AreaField, InputMaskField, LoaderFull },
  data() {
    return {
      canceled: false,
      interval: null,
      comment:  '',
      loader:   false,
      error:    null,
      timer:    0,
      phone:    null,
      step:     0,
      item:     null,
      code:     ''
    }
  },
  computed: {
    avrModel() {
      return this.$store.getters.getAvrModel
    }
  },
  methods: {
    countDownTimer() {
      this.interval = setInterval(() => {
        if (this.timer === 0) {
          clearInterval(this.interval)
          this.timer = 0
        } else {
          this.timer = this.timer - 1
        }
      }, 1000)
    },
    getItemById(id) {
      this.loader = true
      axios.post('/api/avr/item', {id: id})
          .then(res => {
            if (res.data.result) {
              this.item = res.data.data[0]
            } else {
              this.error = res.data.message
            }
          })
          .catch(err => {
            this.error = err
          })
          .finally(() => {
            this.loader = false
          })
    },
    sendConfirmed(id, confirmed) {
      this.loader = true
      let data    = {id: id, confirmed: confirmed}
      if (this.canceled) Object.assign(data, {comment: this.comment})
      axios.post('/api/avr/confirmed', data)
          .then(res => {
            if (res.data.result) {
              if (confirmed === 0) {
                this.modalHidden()
                this.$emit('reload', {reload: true})
              } else {
                this.timer = 120
                this.countDownTimer()
                this.step = 1
                this.phone = res.data.sendPhone
              }
            } else {
              this.error = res.data.message
            }
          })
          .catch(err => {
            console.log(err)
          })
          .finally(() => {
            this.loader = false
          })
    },
    checkCode(id) {
      this.loader = true
      axios.post('/api/avr/check-code', {id: id, code: this.code})
          .then(res => {
            if (res.data.result) {
              this.modalHidden()
              this.$emit('reload', {reload: true})
            } else {
              this.error = res.data.message
              this.code = ''
            }
          })
          .catch(err => {
            this.step = 0
            this.error = err.message
          })
          .finally(() => {
            this.loader = false
          })
    },
    clearForm() {
      this.interval = null
      this.loader   = false
      this.error    = null
      this.timer    = 0
      this.phone    = null
      this.step     = 0
      this.item     = null
      this.code     = ''
    },
    modalHidden() {
      const myModalEl = document.getElementById('avrModal')
      const modal     = bootstrap.Modal.getInstance(myModalEl)
      modal.hide()
      this.$store.dispatch('avrModel', {id: null, title: null})
      this.clearForm()
    }
  },
  watch: {
    avrModel: {
      deep: true,
      handler(newValue) {
        this.clearForm()
        if (newValue.id) this.getItemById(newValue.id)
      }
    },
    code: {
      deep: true,
      handler(newValue) {
        this.step = newValue.length === 4 ? 2 : 1
        if (newValue) this.error = null
      }
    }
  }
}
</script>

<style scoped>
</style>